import React from "react"

import FiftyFiftyBlock from "../shared/FiftyFiftyBlock"

import { FiftyFiftyCardType } from "../../types"

type SolutionCasesProps = {
  title: string
  useCases: FiftyFiftyCardType[]
  alignFirstRight?: boolean
}

const SolutionCases = ({ title, useCases, alignFirstRight }: SolutionCasesProps) => {
  const isOdd = number => !!(number % 2);
  const isEven = number => number % 2 === 0;

  const blocks = useCases?.map((block, i) => (
    <FiftyFiftyBlock
      key={`solution-fifty=${i}`}
      content={block}
      rightAlign={alignFirstRight ? isEven(i) : isOdd(i)}
      isLast={i === useCases.length - 1}
    />
  ))

  return (
    <section className="c-solutionCases">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xxl-10">
            <div className="c-solutionCases__headlineWrapper">
              <h2 className="section-heading section-heading--mobilexs18">
                {title}
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div className="c-solutionCases__blocks">{blocks}</div>
    </section>
  )
}

export default SolutionCases
